import { render, staticRenderFns } from "./PermanentVinyl.vue?vue&type=template&id=668d5934&scoped=true"
import script from "./PermanentVinyl.vue?vue&type=script&lang=js"
export * from "./PermanentVinyl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d5934",
  null
  
)

export default component.exports